import * as React from 'react';
import { connect } from 'react-redux';
import { navigateTo } from '../../../actions/navigationActions';
import { setPortablePossessionType, setQuoteType } from '../../../actions/salesActions';
import {  DESCRIBE_POSSESSION, GATHER_INFO} from '../../../routes/routes';
import './PortablePossessions.css';
import {showCallBackRequest } from '../../../actions/modalActions';
import { PRODUCT_BLING } from '../../../constants/constants';

class PortablePossessionsTile extends React.Component<any, any> {
    constructor(props) {
        super(props)
    }

    async portablePossessionsAddCover(id: number,title: string) {
        if (id === 2) {
            await this.props.dispatchAction(setQuoteType(PRODUCT_BLING))
            this.props.redirectTo(GATHER_INFO);
        } else {
            this.props.dispatchSetPortablePossessionType(id, title);
            await this.props.redirectTo(DESCRIBE_POSSESSION)
        }
    }
    
    public render() {
        return (
            <>
                <div className={"ssp-portable-possessions-tile ssp-portable-possessions-tile-identifyer-" + this.props.icon} title={this.props.title}>
                    <div className="row noma">
                        <div className="col-12 nopa ssp-portable-possessions-col-add-cover" title={"Add Cover: " + this.props.title} onClick={() => this.portablePossessionsAddCover(this.props.portableId,this.props.title)} >
                            <div className="ssp-portable-possessions-tile-add-cover"></div>
                        </div>
                        <div className="col-12 nopa pt-3px ssp-portable-possessions-col-icon" title={this.props.title}>
                            <div className={"ssp-portable-possessions-tile-icon ssp-portable-possessions-tile-" + this.props.icon}></div>
                        </div>
                        <div className="col-12 nopa pt-3px ssp-portable-possessions-col-text">
                            <div className="ssp-portable-possessions-text">
                                {this.props.title}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        ssp: state.ssp,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchSetPortablePossessionType: (id, itemType) => dispatch(setPortablePossessionType(id, itemType)),
        handleCallMeBack: () => dispatch(showCallBackRequest()),
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PortablePossessionsTile);